import { produce } from "immer";
import { useCallback } from "react";

import { selectTableData } from "@ds/modules/table-data/redux/selectors";
import { DEFAULT_TABLE_TAB, tableDataActions } from "@ds/modules/table-data/redux/slice";
import { DetailsTableDataTypeEnum, MainTableDataTypeEnum } from "@ds/modules/table-data/utils/model";

import { useDeepRootSelector, useRootDispatch } from "./redux-hooks";

const EMPTY_TABLE_FILTERS: TableFilters = {};

export const useTableDataFilters = (
  tableType: MainTableDataTypeEnum | DetailsTableDataTypeEnum,
  tableTab = DEFAULT_TABLE_TAB,
  queryFilters?: KeysToCamelCase<QueryFilters>,
) => {
  const { pagination, queryInfo } = useDeepRootSelector(state =>
    selectTableData(state, tableType, tableTab, queryFilters),
  );

  const dispatch = useRootDispatch();
  const setTableFilters = useCallback(
    (tableFilters: TableFilters) =>
      dispatch(
        tableDataActions.updateTableData({
          tableType,
          tableTab,
          pagination: { pageNumber: 1, pageSize: pagination.pageSize },
          queryInfo: produce(queryInfo, draft => {
            draft.tableFilters = tableFilters;
          }),
          options: { shouldDisableSagaThrottling: true },
        }),
      ),
    [dispatch, tableType, tableTab, pagination.pageSize, queryInfo],
  );

  return [queryInfo.tableFilters || EMPTY_TABLE_FILTERS, setTableFilters] as const;
};
